import * as types from '../constants/tradepanelConstants';
import i18next from 'i18next';
const initialState = {
  bmList:[],
  tradeLayout:[],
  alertWindow:{
    label:"",
    MSG:"",
    flag:false,
    TS:null,
  },
  trdingFlag:null,
  popoutLimit:0,
  orderSelectionFlag:false,
  orderStatus:"1",
  wsStatus:'',
  wsMessage: {},
  wsRandomNo: 0
};

const getInitialBMData = (BMList) => {
  return BMList.map((item,index) => {
    return {
      ...item,
      BM:item.bm_code,
      BMD:item.mb_desc,
      PRM:item.prm_comm,
      IID:item.inst_desc,
    };
  });
};
const cutofbenchmrklist = (msg,bmlist) =>{
  const item =Object.assign([],bmlist);
  for(let i=0;i<item.length;i++){
    if(msg.BMC===item[i].BMC){
      item.splice(i, 1);
    }
  }
  localStorage.setItem('bmList', JSON.stringify(item));
  return item;
}
const updatebenchmrklist = (msg,bmlist) =>{
    const item =Object.assign([],bmlist);
  if(msg.P==="A"){
    var obj={
      BMC:msg.BM,
      BMN:msg.BMD,
      BPS:msg.PRM,
      BEMT:msg.BEMT,
      IID:msg.IID
    }
    item.push(obj);
  }else if(msg.P==="E"){
    var obj={
      BMC:msg.BM,
      BMN:msg.BMD,
      BPS:msg.PRM,
      BEMT:msg.BEMT,
      IID:msg.IID
    }
    for(let i=0;i<item.length;i++){
      if(msg.BM===item[i].BMC){
        item[i]=obj;
      }
    }
  } else if(msg.P==="D"){
    for(let i=0;i<item.length;i++){
      if(msg.BM===item[i].BMC){
        item.splice(i, 1);
      }
    }
  }
  localStorage.setItem('bmList', JSON.stringify(item));
  return item;
}
const createAlert = (message) =>{
  return {
    label:i18next.t('msgfrmDealer'),
    MSG:message.MSG,
    flag:true,
    TS:message.TS
  };
}
const closeAlert = (alert) =>{
  alert.flag=false;
  return alert;
}
export default function reducer(state = initialState, action = {}) {
  if(action.type === types.GET_WS_MESSAGE){
    var wsRandomNo = Math.floor((Math.random() * 1000000) + 1);
    return {
      ...state,
      wsMessage: action.msg,
      wsRandomNo: wsRandomNo
    };
  }
  switch (action.type) {
    case types.ORDER_SUCCESS:
      return {
        ...state,
        showPopup: true
      };
    case types.UPDATE_TRADE_SOCKET_DATA:
      return {
        ...state,
      };
    case types.LOAD_TRADE_SOCKET_DATA:
      return {
        ...state,
        wsStatus : 'connected'
      };
    case types.CLOSE_SOCKET_TRADE:
      return {
        ...state,
        wsStatus : 'disconnected'
      };
    case types.HIDE_MODAL:
      return {
        ...state,
        showPopup: false,
        executeSuccess: false,
      };
    case types.EXECUTE_SUCCESS:
      return {
        ...state,
        executeSuccess: true,
        executeData: action.data
      };
      
      // case types.VALIDATE_ORD_API:
      // return{
      //   ...state,
      // };
      // case types.VALIDATE_ORD_API_SUCCESS:
      // console.log('validateOrd', JSON.stringify(action.result.data));
      // return{
      //   ...state,
      //   validOrd:action.result.data
      // };
      // case types.VALIDATE_ORD_API_FAILURE:
      // return{
      //   ...state,
      // };
    case types.GETBM:
      return{
        ...state,
      };
    case types.GETBM_SUCCESS:
      localStorage.setItem('bmList', JSON.stringify(action.result.data));
      return{
        ...state,
        bmList:action.result.data
      //  bmList:getInitialBMData(action.result.data.BM)
      };
    case types.GETBM_FAILURE:
      return{
        ...state,
      };
    case types.SHOW_ALERT:
      //console.log("SHOW_ALERT alertWindow");
      return{
        ...state,
      alertWindow:createAlert(action.msg),
    };
    case types.HIDE_ALERT:
  //  console.log("HIDE_ALERT alertWindow "+JSON.stringify(state.alertWindow));
    return{
      ...state,
    alertWindow:false,
  };
    case types.TRD_STATUS:
      localStorage.setItem('trdingFlag', action.status);
    return{
      ...state,
      trdingFlag:action.status,
    }
    case types.CUTOFF_BENCHMARK:
    return{
      ...state,
      bmList:cutofbenchmrklist(action.message,state.bmList),
    };
    case types.UPDATE_BM_LIST:
    return{
      ...state,
      bmList:updatebenchmrklist(action.message,state.bmList),
    };
    case types.UPDATE_POPOUT_COUNT:
    return{
      ...state,
      popoutLimit:action.popoutLimit,
    };
    case types.CLOSE_WEBSOCKET_TRADE:
    return{
      ...state,
      wsStatus : 'closed'
    };
    case types.UPDATE_STATUS_CHANGE:
    return{
      ...state,
      orderStatus:action.message.S,
      wsStatus : state.wsStatus === 'reconnecting' ? 'reconnect' : null
    };
    case types.UPDATE_ORDER_STATUS:
  return{
    ...state,
    orderStatus:1,
    wsStatus : 'reconnecting'
  };
    default:
        return state;
    }
}
